import { useCallback, useRef } from 'react';

import {
    IS_IFRAME_MODE,
    IFRAME_MODE_MIN_HEIGHT,
    NEW_IFRAME_MODE_MIN_HEIGHT
} from 'config/envVariable';
import * as postMsgEvent from 'config/postMsgEvent';
import useElementResizeObserver from 'hooks/useElementResizeObserver';

export function useHeightResizePostMessage({ useMaxSize = false } = {}) {
    const prevHeight = useRef(0);
    const handler = useCallback(
        element => {
            const height = element.clientHeight;
            const calculateTarget = useMaxSize
                ? [height, prevHeight.current, NEW_IFRAME_MODE_MIN_HEIGHT]
                : [height, IFRAME_MODE_MIN_HEIGHT];
            postHeightMessage(Math.max(...calculateTarget));

            if (height > prevHeight.current) {
                prevHeight.current = height;
            }
        },
        [useMaxSize]
    );
    // 偵測被 ref 綁定的 element 去監測此元素的大小變動，若是 iframe mode 就執行監聽，當 size 改變時，執行 callback handler
    const [, setRef] = useElementResizeObserver({ isEnable: IS_IFRAME_MODE, callback: handler });
    return setRef;
}

// 根據 promo 內部需要的高度發 postMessage 去更新 zine 內 iframe 高度
export function postHeightMessage(height) {
    window.parent.postMessage(
        {
            event: postMsgEvent.HEIGHT_RESIZE,
            payload: { height }
        },
        '*'
    );
    window.parent.postMessage(
        {
            sentinel: 'amp',
            type: 'embed-size',
            height: height
        },
        '*'
    );
}

export function useFixedPopupHeightResizePostMessage({ isTrigger = true } = {}) {
    const handler = useCallback(element => {
        const promoBody = document.getElementById('promo-client-body');
        if (promoBody) {
            const promoBodyHeight = promoBody.clientHeight;
            const { height, top } = element.getBoundingClientRect();
            const bottomPadding = 20;
            const popupElementHeight = top + height + bottomPadding;
            if (popupElementHeight > promoBodyHeight) {
                postHeightMessage(popupElementHeight);
            }
        }
    }, []);
    const unmountHandler = useCallback(() => {
        const promoBody = document.getElementById('promo-client-body');
        if (promoBody) {
            const promoBodyHeight = promoBody.clientHeight;
            postHeightMessage(Math.max(promoBodyHeight, IFRAME_MODE_MIN_HEIGHT));
        }
    }, []);
    const [, setRef] = useElementResizeObserver({
        isEnable: IS_IFRAME_MODE && isTrigger,
        callback: handler,
        unmountCallback: unmountHandler
    });
    return setRef;
}
